export const project = 'nr_only'; // need this for when we dynamically import utils

export const sending = ({ data: { nrPageAction, nrData } }) => {
	window.newrelic.addPageAction(nrPageAction, nrData);

	const reportsForEventViewer = [];

	reportsForEventViewer.push({
		clientEventName: nrPageAction,
		payload: {
			nrPageAction,
			nrData
		},
		sender: 'nr_only->utils/sending'
	});

	return {
		reportsForEventViewer,
		reportsForNewRelic: []
	};
};
